import { IDynamicDiplayView } from '@components/widgets/dynamic-display';
import { IAbstractRecord } from '@models';
import { isEmpty } from '@utils/validationUtils';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';

export const maxCreditLimitView = (
  data: IAbstractRecord
): IDynamicDiplayView => ({
  name: 'Personal Information',
  isCollapsible: true,
  sections: [
    {
      name: 'maximumCreditLimit',
      title: 'Max Credit Limit',
      showActionButtons: true,
      properties: {
        relatedCompany: {
          multiline: false,
          value: data?.maxCreditLimitAllowedCurrencyTitle,
          name: 'maxCreditLimitAllowedCurrency',
          title: 'Max Credit Limit Allowed (Currency)',
        },
        type: {
          multiline: false,
          value: data?.maxCreditLimitAllowedShow,
          name: 'maxCreditLimitAllowed',
          title: 'Max Credit Limit Allowed',
        },
      },
    },
  ],
});

const initialValues = {
  businessPartnerDetails: {
    maxCreditLimitAllowedCurrency: '',
    maxCreditLimitAllowed: 0,
  },
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    sectionTitle: 'Information',
    inputs: {
      maxCreditLimitAllowedCurrency: {
        name: 'maxCreditLimitAllowedCurrency',
        title: 'Max Credit Limit Allowed (Currency)',
        type: FormFieldType.select,
        placeholder: 'Max Credit Limit Allowed (Currency)',
        value: !isEmpty(
          initialValues.businessPartnerDetails.maxCreditLimitAllowedCurrency
        )
          ? initialValues.businessPartnerDetails.maxCreditLimitAllowedCurrency
          : '',
        required: true,
        injectGlobalLov: {
          type: 'currency',
          value: 'Id',
          display: 'Title',
        },
      },
      maxCreditLimitAllowed: {
        name: 'maxCreditLimitAllowed',
        title: 'Max Credit Limit Allowed',
        type: FormFieldType.currency,
        placeholder: 'Max Credit Limit Allowed',
        value: initialValues.businessPartnerDetails.maxCreditLimitAllowed,
        required: true,
      },
    },
  },
];
